import request from "root/js/request";

export const getCompanyPurchaseHistory = async params => {
  const response = await request({
    url: "/company/purchase_history/",
    method: "get",
    params,
  });
  return response.data;
};
